<template class="bible-results-list">  
  <ul 
    id="bible-results" 
    class="py-1 px-0 list-unstyled result-list-wrap"
    >
    <b-modal
      id="mobile-more-modal"
      v-model="showMobileMore"
      hide-footer
      modal-class="p-2"
      no-fade
      header-class="text-center bg-white m-auto"
      @show="modalShow"
      :title="'הרחבה של '+modalTitle.replace(/<\/?[^>]+(>|$)/g, '')"
      @hidden="modalClosed"
      >
      <div v-html="listContent" @click="handleClick"></div>  
    </b-modal>
    
    <li class="py-1 f-koren" 
      @click="handleClick"      
      v-for="(n, index) in resultsToShow" :key="index"
      :class="{'bg-background' : index%2 == 0,
      'mobile-bible-item text-center':mobile,            
      'selected' : checkSelected(defaultResults[index]),
      'dropdown-items' : defaultResults[index].forms != undefined && defaultResults[index].forms.length > 1}">     
      <i v-if="defaultResults[index].forms != undefined && defaultResults[index].forms.length > 1" class="fas fa-bars d-none" @click="openBibleList(index, defaultResults[index].forms[0].split('\t')[0])"></i>
      <i v-if="!mobile" class="far fa-star d-none" @click="bibleAddToList(defaultResults[index])" ></i>
      <i v-if="!mobile" class="fas fa-star d-none" @click="bibleRemoveFromList(defaultResults[index])" ></i>            
      <p class="d-inline m-0" v-html="defaultResults[index].forms != undefined ? defaultResults[index].forms[0].split('\t')[0] : defaultResults[index].split('\t')[0]"></p>
      <small v-if="mobile" class="text-muted border-top mx-n5 mt-1">
        <span class="source" v-html="defaultResults[index].forms != undefined ? defaultResults[index].forms[0].split('\t')[1] : defaultResults[index].split('\t')[1]"></span>
      </small>
      <small v-else class="text-muted mr-2 d-inline-block">
        (<span class="source" v-html="defaultResults[index].forms != undefined ? defaultResults[index].forms[0].split('\t')[1] : defaultResults[index].split('\t')[1]"></span>)
      </small>
      <span class="mx-2" v-if="!overviewMode && !mobile"  @click="openBibleList(index)">
        <small class="text-muted bg-secondary" v-if="defaultResults[index].forms != undefined && defaultResults[index].forms.length > 1">{{defaultResults[index].lex}}, {{defaultResults[index].forms.length}} {{hebrew ? 'תוצאות' : 'results'}}</small>
      </span>
      <ul :id="'list-bible-'+index" class="list-unstyled dropdown bible-dd border-top border-bottom bg-white py-2" 
        v-if="defaultResults[index].forms != undefined && defaultResults[index].forms.length > 1" style="display:none;">
        <li 
          class="pb-1 px-0 sub-results" 
          v-for="(formItem, formIndex) in defaultResults[index].forms" :key="formIndex"
          :class="{'selected-inner' : checkSelected(formItem), 'mobile-bible-item':mobile}"
        >
            <i 
              class="fas fa-square border-right border-bottom text-white position-absolute" 
              aria-hidden="true"
              :class="{'d-none':mobile}"
              ></i>
            <i class="far fa-star d-none" @click="bibleAddToList(formItem)" ></i>
            <i class="fas fa-star d-none" @click="bibleRemoveFromList(formItem)" ></i>
            <div class="px-sm-5">
              <p @click.prevent="handleClick" 
                :class="{'d-inline bible-dd-p':!mobile, 'mb-1 py-1':mobile}"  
                v-html="formItem.split('\t')[0]">
              </p>
              <small v-if="mobile" 
                class="d-block text-muted mx-1 pt-1 border-top border-secondary">
                <span class="source" v-html="formItem.split('\t')[1]"></span>
              </small>
              <small v-else                 
                class="d-inline text-muted mx-1">
                  (<span class="source" v-html="formItem.split('\t')[1]"></span>)
              </small>
            </div>
          </li>
        </ul>
      </li>
      <span v-if="mobile">
        <span ref="trigger"/>
        <div v-if="resultsToShow < defaultResults.length">
          <b-button
            variant="link"
            class="text-primary m-auto text-center d-block" 
            @click="showMoreResults">
            טוען תוצאות נוספות …      
          </b-button>
        </div>
        <div 
          class="text-center"
          v-if="resultsToShow >= defaultResults.length && defaultResults.length > 14"
        >אין תוצאות נוספות</div>
      </span>  
  </ul>
</template>
<script lang="js">
  import listMethods from '@/mixins/ListMethods.js'
  export default  {
  name: 'BibleResultsList',
  props: [],
  mixins: [listMethods],
  data() {
    return {
      listContent: '',
      modalTitle: '',
      wordList: []
    }
  },
  mounted () {
    this.setResultsToShow()
    this.$nextTick(function () {  
      if (this.bibleResponse.length > 0 && !this.overviewMode) {    
        let bMatch = new RegExp("<b>(.*)</b>","i")      
        this.bibleResponse.map (item => {
          if (item.forms && item.forms.length >= 1) {
            item.forms.forEach(frmItem => {
              this.wordList.push(frmItem.match(bMatch)[1])
            })
          }  
          else if (!item.forms || item.forms.length == 0)
            this.wordList.push(item.lex.match(bMatch)[1])
        })
        this.$emit('word-list', this.wordList)     
      }
    })
  },
  methods: {
    setResultsToShow () {
      if(this.defaultResults) { //show all results if desktop, less than 14 or landscape
        this.currentTabLength = this.bibleResponse.length
        if (!this.mobile || this.defaultResults.length <= 14 || window.innerWidth > window.innerHeight) {
          this.resultsToShow = this.defaultResults.length          
        } else {
          this.resultsToShow = 14
        }
      }
    },
    checkSelected (item) {
      let txt = ''
      if (item.forms) {
        txt = item.forms[0]
      } else {
        txt = item
      }
      let bMatch = new RegExp("<b>(.*)</b>","i")
      if (this.selectedWords.length > 0)
        return this.selectedWords.indexOf(txt.match(bMatch)[1].replace( /(<([^>]+)>)/ig, '').replace('-','')) > -1
    },
    bibleAddToList (item) {
    if(!this.mobile) {
      let txt = ''
      if (item.forms) {
        txt = item.forms[0]
      } else {
        txt = item
      }
      let bMatch = new RegExp("<b>(.*)</b>","i")
      this.$store.commit('ADD_WORD_TO_LIST', txt.match(bMatch)[1].replace( /(<([^>]+)>)/ig, '').replace('-',''))
      }
    },
    bibleRemoveFromList (item) {
      if (!this.mobile) {
        let txt = ''
        if (item.forms) {
          txt = item.forms[0]
        } else {
          txt = item
        }
        let bMatch = new RegExp("<b>(.*)</b>","i")
        this.$store.commit('REMOVE_WORD_FROM_LIST', txt.match(bMatch)[1].replace( /(<([^>]+)>)/ig, '').replace('-',''))
      }
    },
    openBibleList(index, txt) {
      var selectedList = document.getElementById('list-bible-'+ index)
      if (this.mobile) {
        let bMatch = new RegExp("<b>(.*)</b>","i")
        this.modalTitle = txt.match(bMatch)[1]
        this.listContent = selectedList.innerHTML
        this.savedPos = window.scrollY
        this.showMobileMore = true
      } else {
        if (selectedList) {
          if (selectedList.style.display === "none") {
            selectedList.style.display = "block";
          } else {
            selectedList.style.display = "none";
          }
        }
      }
    },    
    handleClick(e) {
      var data = e.srcElement.localName
      if(data == 'b') {
        var searchTerm = e.srcElement.innerText
        if (searchTerm[0] === '־')
          searchTerm =  searchTerm.substring(1)
        window.open('https://search.dicta.org.il/he/result?text='+ searchTerm, '_blank') 
      }
      if (this.mobile) {  
        this.copyMobileResult(e)
      }  
    }      
  },
  computed: {
    bibleFmore () {
      return this.searchModel === 'xxsonance' ? this.assonanceMode ? 
        this.$store.state.bibleMoreResultsAS : this.consonanceMode ? 
        this.$store.state.bibleMoreResultsCON : this.assonanceConsonanceOff ? false : this.$store.state.bibleMoreResults  : this.$store.state.bibleMoreResults
    },      
    bibleRhymeResultsSlice () {
      return this.bibleResponse.slice(0, 10)
    },     
    defaultResults () {
      this.$emit('biblicalResults', this.bibleResponse.length, this.bibleFmore)
      return this.overviewMode && !this.mobile ? this.bibleRhymeResultsSlice : this.bibleResponse
    }      
  },
  watch: {
    defaultResults () {                  
      this.setResultsToShow()      
    }
  }
}
</script>

<style scoped lang="scss">
  @import "list";
  #bible-results {
    li{    
      i {
        top: 15px;
        &.fa-square {
          top: 8px;
        }
      }  
    }
    .bible-dd {
      .fa-star {
        top: 8px;
      }
    }
  }
</style>
